import { SchedulePickerActionBody, SchedulePickerProps, SchedulePickerState, SubscriptionFrequency } from './SchedulePickerActionBody';
import * as React from 'react';
import { DropdownButtonType, List, ListItem, SingleSelectDropdown } from '@tableau/widgets';
import { ReactActionDialogBodyProps } from '~src/commonInfra/dialogs/ReactActionDialog';
import { Messages } from '~src/codegen/Localize';

export type SubscriptionSchedulePickerProps = SchedulePickerProps & {
  readonly selectedSubscriptionFrequency: SubscriptionFrequency;
}

export type PropsForSubscriptionSchedulePickerActionBody = ReactActionDialogBodyProps<SubscriptionSchedulePickerProps, SchedulePickerState | undefined>;

export function SubscriptionSchedulePickerActionBody(props: PropsForSubscriptionSchedulePickerActionBody) {
  const [selectedScheduleOption, setSelectedScheduleOption] = React.useState(props.selectedSubscriptionFrequency);

  const scheduleOptions: ListItem[] = [
    {
      value: SubscriptionFrequency.onSelectedSchedule,
      content: Messages.changeSubscriptionsFrequencyOptionOnSelectedSchedule(),
    },
    {
      value: SubscriptionFrequency.onExtractRefresh,
      content: Messages.changeSubscriptionsFrequencyOptionOnExtractRefresh(),
    }
  ];

  const onSelectScheduleOption = React.useCallback(
    (value: SubscriptionFrequency) => {
      props.updateDialogState({ selectedScheduleOption: value });
      setSelectedScheduleOption(value);
    },
    [props.updateDialogState, selectedScheduleOption]
  );
  const dropdown = <SingleSelectDropdown
    label=''
    list={<List items={scheduleOptions} />}
    type={DropdownButtonType.Outline}
    onChange={onSelectScheduleOption}
    value={selectedScheduleOption}
  />;
  const schedulePicker = SchedulePickerActionBody(props);
  return <>
    { dropdown }
    { selectedScheduleOption === SubscriptionFrequency.onExtractRefresh
       ? <p className='onExtractRefresh-description'>{Messages.subscribeOnExtractRefreshPrompt()}</p>
       : schedulePicker
    }
  </>;
}
